/**
 * Telemetria de produto (PostHog). Só inicializa quando chave e host estão definidos.
 * Variáveis: `VITE_PUBLIC_POSTHOG_PROJECT_TOKEN`, `VITE_PUBLIC_POSTHOG_HOST` (ex.: EU `https://eu.i.posthog.com`).
 */
export function isPosthogConfigured(): boolean {
  const key = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN
  const host = import.meta.env.VITE_PUBLIC_POSTHOG_HOST
  return Boolean(typeof key === 'string' && key.trim() && typeof host === 'string' && host.trim())
}
